import { BlindConfigService } from "../../../Common/BlindConfigurations/BlindConfigService";
export class SsrVersionedService extends BlindConfigService {
}
//# sourceMappingURL=SsrVersionedService.js.map